import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useRole } from '@/hooks/useRole';
import { useAuth } from '@/contexts/AuthContext';

export const RoleRedirect = ({ children }: { children: React.ReactNode }) => {
  const { roles, isLoading } = useRole();
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isAuthenticated) return;
    
    if (!isLoading && roles.length === 0) {
      navigate('/role-selection');
    }
  }, [isAuthenticated, isLoading, roles, navigate]);

  if (isLoading) {
    return null;
  }

  return <>{children}</>;
};
